import apple from "../../../assets/icons/apple.svg";
import google from "../../../assets/icons/google.svg";
import kakao from "../../../assets/icons/kakao.svg";

export const getLastOAuthProviderIcon = (oauthList = []) => {
  if (!oauthList || oauthList.length === 0) return null;
  const lastLoginOauth = oauthList.find((oauth) => oauth.lastLogin);
  if (!lastLoginOauth) return null;

  return getOAuthIcon(lastLoginOauth.provider);
};

export const getOAuthIcon = (provider) => {
  switch (provider) {
    case "google":
      return (
        <div>
          <div style={{ border: "1px solid #dddddd", width: "20px", height: "20px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "5px" }}>
            <img src={google} alt="Google" style={{ width: 14, height: 14 }} />
          </div>
        </div>
      );
    case "kakao":
      return (
        <div>
          <div style={{ background: "#FCE40B", width: "20px", height: "20px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "5px" }}>
            <img src={kakao} alt="Kakao" style={{ width: 14, height: 14 }} />
          </div>
        </div>
      );
    case "apple":
      return (
        <div>
          <div style={{ border: "1px solid #dddddd", width: "20px", height: "20px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "5px" }}>
            <img src={apple} alt="Naver" style={{ width: 14, height: 14 }} />
          </div>
        </div>
      );
    default:
      return null;
  }
};
